import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { ProDriverLicenseType } from "@/gql/graphql";

export function LicenseTypeInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  return (
    <SelectInput
      options={[
        {
          label: "License Type",
          options: [
            {
              label: "Standard",
              value: ProDriverLicenseType.Standard,
            },
            {
              label: "Heavy",
              value: ProDriverLicenseType.Heavy,
            },
          ],
        },
      ]}
      {...props}
    />
  );
}
